module.exports = __webpack_public_path__ + "static/media/informedConsent_couple.4e713b2d.jpeg";